<template>
  <NavbarDropdown
    :items="items"
    :active="active"
    :text="active.code != null ? label(active) : $t('general.loading')"
    @click:item="onClick"
  />
</template>

<script>
import NavbarDropdown from './NavbarDropdown.vue'
import {find} from "lodash-es";
import AdminStore from "../stylemix-vue-admin/store";

export default {
  name: 'NavbarCurrency',

  components: {
    NavbarDropdown,
  },

  data() {
    return {
      active: {
        code: this.$root.$account !== null ? this.$root.$account.currency.code : null,
        symbol: this.$root.$account !== null ? this.$root.$account.currency.symbol : null,
      },
      items: [],
    }
  },

  updated() {
    if(this.active.code === null) {
      this.active = this.$root.$account.currency
    }
  },

  mounted() {
    this.$http.get('currencies').then(response => {
      response.data.data.map((c) => {
        this.items.push(
          {
            id: c.code,
            isActive: c.code === this.active.code,
            label: this.label(c),
            origin: c,
          }
        )
      })
    })
  },

  methods: {
    label(currency) {
      return `${currency.code} (${currency.symbol})`
    },

    onClick(item) {
      this.active = item.origin
      this.items.map( function (item) {
        return item.isActive = false;
      })
      find(this.items, { id: this.active.code}).isActive = true;
      this.switchCurrency(item.origin)
    },

    switchCurrency(currency) {
      this.$http.post('users/' + this.$root.$account.id + '/update-currency', {currency_code: currency.code})
        .then(response => {
          AdminStore.commit('admin-auth/switchCurrency', response.data.data)
          if (this.$route.name === 'bookings.create') {
            setTimeout(window.location.reload(), 1500);
          }

        }).catch(err => this.$toast.error(err.response.data.message));
    },
  },
}
</script>
